<div class="loadingOverlay">
  <div class="loadingOverlay-inner">
    <div class="loadingOverlay-dots"><span>.</span><span>.</span><span>.</span></div>
  </div>
</div>
